
import { Vue, Component, Prop } from 'vue-property-decorator'
import IconCtrl from '~/components/common/icon/IconCtrl.vue'

@Component({
  name: 'BodyApplicationReview',
  components: {
    IconCtrl
  }
})
export default class BodyApplicationReview extends Vue {
  @Prop() tooltipText!: string

  private showTooltip = false
  private tooltipIsClicked = false

  tooltipSwitcher() {
    if (!this.tooltipIsClicked) {
      this.tooltipIsClicked = true
      this.showTooltip = false
    } else {
      this.tooltipIsClicked = false
      this.showTooltip = true
    }
  }
}
